module.exports = __webpack_public_path__ + "static/1_1_reason-4-ba8002e80f4160e47b101b2714984669.svg";